module.exports = __webpack_public_path__ + "img/img-5.6fb53124.webp";